module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f07457_logo_200x200.4b7472e5.png";